import Component from "../../lib/component";
import {crumple} from "../../helpers/element";

export const ContactSubmissionFormConfig = {
    componentTypeKey: 'ContactSubmissionForm',
    baseHtmlClass: 'js--contact_submission_form',
    selector: '.js--contact_submission_form',

    datasetConfigKey: 'contact_submission_form',

    hpSelector: '.js--contact_submission_form__name_input',
};

export class ContactSubmissionForm extends Component {

    static get config() {
        return ContactSubmissionFormConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: ContactSubmissionForm.config
        });

        this.hpElement = this.element.querySelector(ContactSubmissionForm.config.hpSelector);

        this.renderInitial();
        this.render();
    }

    renderInitial() {
        if (this.hpElement) this.renderHp();
    }

    render() {
        const urlInputElement = this.element.querySelector('[name="contact_submission[url]"]');
        if (urlInputElement) urlInputElement.value = window.location.href;
    }

    renderHp() {
        crumple(this.hpElement); // Hide and disable the honeypot element.
    }


}
